import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const TABLE_HEADERS = [
  { label: "Item", align: "left" },
  { label: "Qty", align: "left" },
  { label: "Material ready", align: "left" },
  { label: "Service centre", align: "left" },
  { label: "Processing", align: "left" },
  { label: "Logistics", align: "left" },
  { label: "Non-working", align: "left" },
  { label: "Committed", align: "left" },
];

const ItemRow = ({ item }) => {
  return (
    <TableRow
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
        "& td": { py: 2, px: 1.5, verticalAlign: "top", whiteSpace: "nowrap" },
      }}
    >
      <TableCell sx={{ minWidth: 200, whiteSpace: "normal" }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#111827" }}>
          {item.name}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "text.secondary", mt: 0.25 }}>
          {item.subtitle}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#111827" }}>
          {item.quantity}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography sx={{ fontSize: "13px", color: "#374151" }}>
          {item.materialReady}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography sx={{ fontSize: "13px", color: "#374151" }}>
          {item.serviceCentre}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography sx={{ fontSize: "13px", color: "#374151" }}>
          {item.processing}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography sx={{ fontSize: "13px", color: "#374151" }}>
          {item.logistics}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography sx={{ fontSize: "13px", color: "#374151" }}>
          {item.nonWorking}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>
          {item.committedDate}
        </Typography>
        {item.isOrderDateSetter && (
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              color: "#1D4ED8",
              mt: 0.25,
            }}
          >
            {item.tag || "Sets order date"}
          </Typography>
        )}
      </TableCell>
    </TableRow>
  );
};

ItemRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    subtitle: PropTypes.string,
    quantity: PropTypes.string,
    materialReady: PropTypes.string,
    serviceCentre: PropTypes.string,
    processing: PropTypes.string,
    logistics: PropTypes.string,
    nonWorking: PropTypes.string,
    committedDate: PropTypes.string,
    isOrderDateSetter: PropTypes.bool,
    tag: PropTypes.string,
  }).isRequired,
};

const CommittedItemsTable = ({ items, formulaNote }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        border: "1px solid #E5E7EB",
        borderRadius: "16px",
        p: { xs: 2, sm: 3 },
        mt: 3,
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: 700,
          color: "#111827",
          mb: 2,
        }}
      >
        Committed date by item
      </Typography>

      <TableContainer
        sx={{
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            height: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#F3F4F6",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#D1D5DB",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: "#9CA3AF",
            },
          },
        }}
      >
        <Table sx={{ minWidth: 950 }}>
          <TableHead>
            <TableRow>
              {TABLE_HEADERS.map((header) => (
                <TableCell
                  key={header.label}
                  align={header.align}
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "text.secondary",
                    py: 1.5,
                    px: 1.5,
                    borderBottom: "1px solid #E5E7EB",
                    whiteSpace: "nowrap",
                  }}
                >
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <ItemRow key={item.id} item={item} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {formulaNote && (
        <Box sx={{ borderTop: "1px solid #F3F4F6", pt: 2, mt: 2 }}>
          <Typography
            sx={{
              fontSize: "12px",
              color: "text.secondary",
              lineHeight: 1.5,
            }}
          >
            {formulaNote}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

CommittedItemsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  formulaNote: PropTypes.string,
};

export default CommittedItemsTable;
